module.exports = __webpack_public_path__ + "7f8091a78bed4c5b9184293dc452ea91.svg";